export function getCookie(name) {

  
  let cookieValue = null
  
  // eslint-disable-next-line yoda
  if (document.cookie && document.cookie !== "") {
    let cookies = document.cookie.split(";"), i, cookie
    // eslint-disable-next-line no-magic-numbers
    for (i = 0; i < cookies.length; i++) {
      cookie = cookies[i].trim()
      
      /** Does this cookie string begin with the name we want? */
      // eslint-disable-next-line no-magic-numbers
      if (cookie.substring(0, name.length + 1) === (`${name}=`)) {
        // eslint-disable-next-line no-magic-numbers
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
        break
      }
    }
  }
  return cookieValue
  
}




// WEBPACK FOOTER //
// ./src/js/resource/cookie.js